import { useState, useCallback, useMemo, useRef, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import {
  LayoutDashboard,
  Users,
  User,
  Settings,
  ChevronDown,
  ChevronRight,
  Bus,
  BarChart3,
  HeartHandshake,
  Search,
  Network,
  ClipboardCheck,
  Bell,
  PanelLeftClose,
  PanelLeft,
  Armchair,
  Car,
  CalendarDays,
  CalendarHeart,
  ScrollText,
  Fingerprint,
  UsersRound,
  DollarSign,
  FileText,
  Briefcase,
  UserPlus,
  Target,
  Clock,
  Building2,
  Megaphone,
  GitPullRequest,
  UserCircle,
  Shield,
  Eye,
  X,
  ArrowLeftRight,
  BookOpen,
  Monitor,
  BadgePercent,
  HandCoins,
  Landmark,
  Scale,
  Gift,
  ListChecks,
  Check,
  Ticket,
  LogOut,
  Package,
} from "lucide-react";
import { GlobalContext } from "../context/Context";
// import { AvatarGradient } from "../shared/AvatarGradient";

function cn(...inputs) {
  const classes = [];

  const walk = (input) => {
    if (!input) return;

    if (typeof input === "string" || typeof input === "number") {
      classes.push(input);
    } else if (Array.isArray(input)) {
      input.forEach(walk);
    } else if (typeof input === "object") {
      for (const key in input) {
        if (input[key]) classes.push(key);
      }
    }
  };

  inputs.forEach(walk);
  return classes.join(" ");
}

// Static permission/auth data (no context dependency)
function hasPermissionStatic() {
  return true;
}

const STATIC_ROLE_SLUG = "admin";

const STATIC_USER = {
  firstName: "Admin",
  lastName: "User",
  email: "admin@example.com",
  profilePhoto: null,
  roleSlug: STATIC_ROLE_SLUG,
  systemOwner: false,
  isDelegatedSuperAdmin: false,
};

function staticLogout() {}

// Static app/org context data (no context dependency)
const STATIC_APPS = [
  { id: 1, name: "Sales", slug: "sales", description: "Sales Hub", icon: null, status: "active", sortOrder: 1, hasAccess: true, roleId: null },
  // { id: 2, name: "Payroll", slug: "payroll", description: "Payroll Management", icon: null, status: "active", sortOrder: 2, hasAccess: true, roleId: null },
];

const STATIC_ACTIVE_APP = STATIC_APPS[0];

const STATIC_ORGS = [
  { id: 1, name: "My Organization", slug: "my-org", description: null, logo: null, employeeCount: 0 },
];

const STATIC_ACTIVE_ORG = STATIC_ORGS[0];

const STATIC_ACTIVE_ROLE = {
  roleSlug: STATIC_ROLE_SLUG,
  roleName: "Admin",
  isViewAs: false,
  permissions: [],
};

function noop() {}

const CANONICAL_HRMS_NAV = [
  {
    module: "Overview",
    name: "Overview",
    path: "/overview",
    icon: LayoutDashboard,
    section: "Overview",
  },
  {
    module: "Management",
    name: "Dashboard",
    path: "/management",
    icon: LayoutDashboard,
    section: "Overview",
  },
  // {
  //   module: "Product",
  //   name: "Product",
  //   path: "/product",
  //   icon: Package,
  //   section: "Overview",
  // },
  {
    module: "Agents",
    name: "Agents",
    path: "/agents",
    icon: Users,
    section: "Reports",
  },
  {
    module: "Teams",
    name: "Teams",
    path: "/teams",
    icon: UsersRound,
    section: "Reports",
  },
  {
    module: "Units",
    name: "Units",
    path: "/units",
    icon: Building2,
    section: "Reports",
  },
  
];

const PLATFORM_NAV = [
  // { name: "User Management", path: "#", icon: Users }, //  /platform/users
  // { name: "Org Management", path: "#", icon: Building2 }, //  /platform/organisations
  // { name: "Delegation Controls", path: "#", icon: Shield }, //  /platform/delegation
  // { name: "Successor Designation", path: "#", icon: UserPlus }, //  /platform/succession
  // { name: "Ownership Transfer", path: "#", icon: ArrowLeftRight }, //  /platform/transfer
  // { name: "System Audit Log", path: "#", icon: ScrollText }, //  /platform/audit-log
];

const CANONICAL_PAYROLL_NAV = [
  {
    module: "payroll",
    name: "Dashboard",
    path: "/payroll",
    icon: LayoutDashboard,
    section: "My Payroll",
  },
  {
    module: "payroll",
    name: "My Payslips",
    path: "/payroll/payslips",
    icon: FileText,
    section: "My Payroll",
  },
  {
    module: "payroll",
    name: "Tax Summary",
    path: "/payroll/tax",
    icon: DollarSign,
    section: "My Payroll",
  },
  {
    module: "payroll",
    name: "Tax Calculator",
    path: "/payroll/tax-calculator",
    icon: BadgePercent,
    section: "My Payroll",
  },
  {
    module: "payroll",
    name: "My Benefits",
    path: "/payroll/benefits",
    icon: Briefcase,
    section: "My Payroll",
  },
  {
    module: "payroll",
    name: "My Loans",
    path: "/payroll/loans",
    icon: HandCoins,
    section: "My Payroll",
  },
  {
    module: "payroll-admin",
    name: "Run Payroll",
    path: "/payroll/run",
    icon: DollarSign,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Payroll Archive",
    path: "/payroll/archive",
    icon: ScrollText,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Salary Structures",
    path: "/payroll/salary",
    icon: Building2,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Loans & Advances",
    path: "/payroll/loans-admin",
    icon: HandCoins,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Benefits Admin",
    path: "/payroll/benefits-admin",
    icon: Briefcase,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Insurance Claims",
    path: "/payroll/insurance-claims",
    icon: Shield,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Statutory",
    path: "/payroll/statutory",
    icon: Landmark,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Tax Slabs",
    path: "/payroll/tax-slabs",
    icon: BadgePercent,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "Tax Configuration",
    path: "/payroll/tax-config",
    icon: FileText,
    section: "Management",
  },
  {
    module: "payroll-admin",
    name: "F&F Settlements",
    path: "/payroll/ff-settlements",
    icon: Scale,
    section: "Management",
  },
  {
    module: "settings",
    name: "Commission Charts",
    path: "/settings/commission-charts",
    icon: BarChart3,
    section: "Configuration",
  },
  {
    module: "reports",
    name: "Monthly Summary",
    path: "/payroll/reports/monthly",
    icon: BarChart3,
    section: "Reports",
  },
  {
    module: "reports",
    name: "Payroll Register",
    path: "/payroll/reports/register",
    icon: FileText,
    section: "Reports",
  },
  {
    module: "reports",
    name: "Tax Deductions",
    path: "/payroll/reports/tax",
    icon: BadgePercent,
    section: "Reports",
  },
  {
    module: "reports",
    name: "Bank Disbursement",
    path: "/payroll/reports/bank",
    icon: Landmark,
    section: "Reports",
  },
  {
    module: "reports",
    name: "Statutory Reports",
    path: "/payroll/reports/statutory",
    icon: ScrollText,
    section: "Reports",
  },
  {
    module: "payroll-admin",
    name: "Payroll Settings",
    path: "/payroll/settings",
    icon: Settings,
    section: "Administration",
  },
];

const CANONICAL_RECRUIT_NAV = [
  {
    module: "dashboard",
    name: "Dashboard",
    path: "/",
    icon: LayoutDashboard,
    section: "Overview",
  },
  {
    module: "dashboard",
    name: "Pipeline",
    path: "/pipeline",
    icon: Target,
    section: "Overview",
  },
  {
    module: "dashboard",
    name: "My Referrals",
    path: "/referrals",
    icon: UserPlus,
    section: "Referrals",
  },
  {
    module: "employees",
    name: "Open Positions",
    path: "/positions",
    icon: Target,
    section: "Hiring",
  },
  {
    module: "employees",
    name: "Candidates",
    path: "/candidates",
    icon: Users,
    section: "Hiring",
  },
  {
    module: "employees",
    name: "Job Postings",
    path: "/postings",
    icon: Briefcase,
    section: "Talent",
  },
  {
    module: "employees",
    name: "Interview Schedules",
    path: "/interviews",
    icon: CalendarDays,
    section: "Talent",
  },
  {
    module: "settings",
    name: "Settings",
    path: "/settings",
    icon: Settings,
    section: "Administration",
  },
];

const SECTION_ORDER_HRMS = [
  "Overview",
  "Reports",
  "My Space",
  "My Team",
  "My Teams",
  "My Department",
  "My Divisions",
  "People",
  "Workforce",
  "Company",
  "Workspace",
  "Insights",
  "Administration",
  "Platform",
];
const SECTION_ORDER_PAYROLL = [
  "My Payroll",
  "Management",
  "Configuration",
  "Reports",
  "Administration",
];
const SECTION_ORDER_RECRUIT = [
  "Overview",
  "Referrals",
  "Hiring",
  "Talent",
  "Administration",
];

function buildNavSections(canonicalItems, sectionOrder, hasPermission, extras) {
  const allItems = [...canonicalItems, ...(extras ?? [])];
  const visible = allItems.filter((item) =>
    hasPermission(item.module, "canView"),
  );

  const sectionMap = new Map();
  for (const item of visible) {
    if (!sectionMap.has(item.section)) sectionMap.set(item.section, []);
    sectionMap
      .get(item.section)
      .push({ name: item.name, path: item.path, icon: item.icon });
  }

  const sections = [];
  for (const label of sectionOrder) {
    const items = sectionMap.get(label);
    if (items && items.length > 0) {
      sections.push({ label, items });
    }
  }
  return sections;
}

function slugToSidebarRole(slug) {
  if (slug === "admin") return "super_admin";
  if (slug === "system_owner") return "super_admin";
  if (slug === "hr_admin") return "hr_admin";
  if (slug === "president") return "president";
  if (slug === "dept_head") return "dept_head";
  if (slug === "manager") return "manager";
  if (slug === "department_lead") return "team_lead";
  return "employee";
}

// ── AppSwitcher (inlined) ─────────────────────────────────────────────

const SLUG_TO_ICON = {
  people: Users,
  payroll: DollarSign,
  recruit: UserPlus,
  fleet: Car,
  projects: BarChart3,
  ticketing: Ticket,
};

const SLUG_TO_GRADIENT = {
  people: "from-blue-500 to-cyan-400",
  payroll: "from-emerald-500 to-green-400",
  recruit: "from-violet-500 to-purple-400",
  fleet: "from-indigo-500 to-blue-400",
  projects: "from-orange-500 to-amber-400",
  ticketing: "from-slate-500 to-gray-400",
};

function AppPopoutPanel({ onClose, sidebarWidth }) {
  const apps = STATIC_APPS;
  const activeApp = STATIC_ACTIVE_APP;
  const setActiveAppSlug = noop;
  const currentRoleSlug = STATIC_ROLE_SLUG;
  const navigate = useNavigate();

  const isAdminOrHr = currentRoleSlug === "admin" || currentRoleSlug === "hr_admin" || currentRoleSlug === "system_owner";
  const activeApps = apps.filter(a => a.status === "active" && a.hasAccess);
  const comingSoonApps = apps.filter(a => a.status === "coming_soon" || a.status === "disabled" || !a.hasAccess);

  return (
    <div
      className="fixed z-50 bg-[#1a1c2e] rounded-xl border border-white/10 shadow-2xl animate-in slide-in-from-left-2 duration-200"
      style={{
        left: sidebarWidth + 12,
        top: 12,
        width: 268,
      }}
    >
      <div className="px-3 pt-3 pb-1">
        <span className="text-[9px] font-bold uppercase text-white/30 tracking-[0.12em]">YOUR APPS</span>
      </div>
      {activeApps.map((a) => {
        const isActive = a.slug === activeApp?.slug;
        const Icon = SLUG_TO_ICON[a.slug] ?? Users;
        const gradient = SLUG_TO_GRADIENT[a.slug] ?? "from-gray-500 to-gray-400";
        return (
          <button
            key={a.id}
            onClick={() => { setActiveAppSlug(a.slug); onClose(); }}
            className={cn(
              "w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors cursor-pointer",
              isActive ? "bg-blue-500/10" : "hover:bg-white/[0.04]"
            )}
          >
            <div
              className={cn("rounded-md bg-gradient-to-br flex items-center justify-center flex-shrink-0", gradient)}
              style={{ width: 28, height: 28 }}
            >
              <Icon className="w-3.5 h-3.5 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <div className={cn("text-[13px] font-medium truncate", isActive ? "text-blue-400" : "text-white/90")}>
                {a.name}
              </div>
              <div className="text-[10px] text-white/35 truncate">{a.description ?? ""}</div>
            </div>
            {isActive && <Check className="w-4 h-4 text-blue-400 flex-shrink-0" />}
          </button>
        );
      })}

      {isAdminOrHr && (
        <>
          <div className="mx-3 my-1.5 h-px bg-white/[0.08]" />
          <div className="px-3 pt-1 pb-1">
            <span className="text-[9px] font-bold uppercase text-white/30 tracking-[0.12em]">ADMIN</span>
          </div>
          <button
            onClick={() => { navigate("/admin"); onClose(); }}
            className="w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors cursor-pointer hover:bg-white/[0.04]"
          >
            <div
              className="rounded-md bg-gradient-to-br from-violet-500 to-purple-400 flex items-center justify-center flex-shrink-0"
              style={{ width: 28, height: 28 }}
            >
              <Settings className="w-3.5 h-3.5 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-medium text-white/90 truncate">Admin Console</div>
              <div className="text-[10px] text-white/35 truncate">System configuration & audit</div>
            </div>
          </button>
        </>
      )}

      {comingSoonApps.length > 0 && (
        <>
          <div className="mx-3 my-1.5 h-px bg-white/[0.08]" />
          <div className="px-3 pt-1 pb-1">
            <span className="text-[9px] font-bold uppercase text-white/30 tracking-[0.12em]">COMING SOON</span>
          </div>
          {comingSoonApps.map((a) => {
            const Icon = SLUG_TO_ICON[a.slug] ?? Users;
            const gradient = SLUG_TO_GRADIENT[a.slug] ?? "from-gray-500 to-gray-400";
            return (
              <div
                key={a.id}
                className="w-full flex items-center gap-2.5 px-3 py-2 opacity-[0.35] cursor-default"
              >
                <div
                  className={cn("rounded-md bg-gradient-to-br flex items-center justify-center flex-shrink-0", gradient)}
                  style={{ width: 28, height: 28 }}
                >
                  <Icon className="w-3.5 h-3.5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[13px] font-medium text-white/90 truncate">{a.name}</div>
                  <div className="text-[10px] text-white/35 truncate">{a.description ?? ""}</div>
                </div>
                <span className="text-[9px] font-medium text-white/50 bg-white/10 px-1.5 py-0.5 rounded-full flex-shrink-0">Soon</span>
              </div>
            );
          })}
        </>
      )}
      <div className="h-1" />
    </div>
  );
}

function AppSwitcher({ isCollapsed, isOpen, onToggle, onClose, sidebarWidth }) {
  const ref = useRef(null);
  const activeApp = STATIC_ACTIVE_APP;
  const apps = STATIC_APPS;

  const currentApp = activeApp ?? apps.find(a => a.status === "active") ?? null;
  const Icon = currentApp ? (SLUG_TO_ICON[currentApp.slug] ?? Users) : Users;
  const gradient = currentApp ? (SLUG_TO_GRADIENT[currentApp.slug] ?? "from-gray-500 to-gray-400") : "from-blue-500 to-cyan-400";

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function handleEscape(e) {
      if (e.key === "Escape") onClose();
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (isCollapsed) {
    return (
      <div className="relative px-2 py-3" ref={ref}>
        <button
          onClick={onToggle}
          className="flex justify-center w-full cursor-pointer hover:opacity-80 transition-opacity"
          title={`OpraviQ · ${currentApp?.name ?? "Apps"}`}
        >
          <div
            className={cn("rounded-md bg-gradient-to-br flex items-center justify-center flex-shrink-0", gradient)}
            style={{ width: 32, height: 32 }}
          >
            <Icon className="w-4 h-4 text-white" />
          </div>
        </button>
        {isOpen && <AppPopoutPanel onClose={onClose} sidebarWidth={sidebarWidth} />}
      </div>
    );
  }

  return (
    <div className="relative px-3 py-3" ref={ref}>
      <button
        // onClick={onToggle}
        className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-all cursor-pointer hover:bg-white/[0.06]"
      >
        <div
          className={cn("rounded-md bg-gradient-to-br flex items-center justify-center flex-shrink-0", gradient)}
          style={{ width: 32, height: 32 }}
        >
          <Icon className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1 text-left min-w-0">
          <div className="text-[13px] font-heading font-bold text-white truncate leading-tight">{currentApp?.name ?? "Apps"}</div>
          <div className="text-[9px] text-white/40 leading-none mt-0.5">OpraviQ Platform</div>
        </div>
        {/* <ChevronDown className={cn("w-3.5 h-3.5 text-white/50 transition-transform flex-shrink-0", isOpen && "rotate-180")} /> */}
      </button>

      {isOpen && <AppPopoutPanel onClose={onClose} sidebarWidth={sidebarWidth} />}
    </div>
  );
}

// ── OrgSwitcher (inlined) ─────────────────────────────────────────────

const DOT_COLORS = [
  "bg-emerald-400",
  "bg-blue-400",
  "bg-amber-400",
  "bg-purple-400",
  "bg-rose-400",
  "bg-cyan-400",
];

function OrgSwitcher({ isCollapsed, isOpen, onToggle, onClose }) {
  const ref = useRef(null);
  const orgs = STATIC_ORGS;
  const activeOrg = STATIC_ACTIVE_ORG;
  const setActiveOrgId = noop;

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function handleEscape(e) {
      if (e.key === "Escape") onClose();
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (isCollapsed) return null;

  const currentOrg = activeOrg ?? orgs[0];
  if (!currentOrg) return null;

  return (
    <div className="relative px-3 py-2" ref={ref}>
      <button
        // onClick={onToggle}
        className="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:bg-white/[0.06] transition-all cursor-pointer"
      >
        <span className={cn("w-2 h-2 rounded-full flex-shrink-0", DOT_COLORS[orgs.indexOf(currentOrg) % DOT_COLORS.length])} />
        <span className="text-[12px] text-white/80 truncate flex-1 text-left">{currentOrg.name}</span>
        <span className="text-[10px] text-white/30 flex-shrink-0">{currentOrg.employeeCount}</span>
        <span className="text-[8px] font-semibold text-white/30 bg-white/[0.08] px-1.5 py-0.5 rounded uppercase tracking-wider flex-shrink-0">Org</span>
        {/* <ChevronDown className={cn("w-3 h-3 text-white/40 transition-transform flex-shrink-0", isOpen && "rotate-180")} /> */}
      </button>

      {isOpen && (
        <div className="absolute left-3 right-3 top-full mt-1 bg-[#1e2030] rounded-xl border border-white/10 shadow-2xl z-50 py-1">
          <div className="px-3 pt-2.5 pb-1">
            <span className="text-[9px] font-bold uppercase text-white/30 tracking-[0.12em]">ORGANIZATIONS</span>
          </div>
          {orgs.map((o, idx) => {
            const isActive = o.id === currentOrg.id;
            return (
              <button
                key={o.id}
                onClick={() => { setActiveOrgId(o.id); onClose(); }}
                className={cn(
                  "w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors cursor-pointer",
                  isActive ? "bg-blue-500/10" : "hover:bg-white/[0.04]"
                )}
              >
                <span className={cn("w-2.5 h-2.5 rounded-full flex-shrink-0", DOT_COLORS[idx % DOT_COLORS.length])} />
                <div className="flex-1 min-w-0">
                  <div className={cn("text-[13px] font-medium truncate", isActive ? "text-blue-400" : "text-white/90")}>
                    {o.name}
                  </div>
                  <div className="text-[10px] text-white/30">{o.employeeCount} member{o.employeeCount !== 1 ? "s" : ""}</div>
                </div>
                {isActive && <Check className="w-4 h-4 text-blue-400 flex-shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── UserCard (inlined) ────────────────────────────────────────────────


function getInitials(name) {
  if (!name) return "U";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
}

const AVATAR_GRADIENTS = [
  "from-[#6366F1] to-[#8B5CF6]",
  "from-[#EC4899] to-[#F43F5E]",
  "from-[#14B8A6] to-[#06B6D4]",
  "from-[#F59E0B] to-[#EF4444]",
  "from-[#10B981] to-[#3B82F6]",
  "from-[#8B5CF6] to-[#EC4899]",
];

function getAvatarGradient(name) {
  let hash = 0;
  for (let i = 0; i < name?.length; i++) {
    hash = name?.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_GRADIENTS.length;
  return AVATAR_GRADIENTS[index];
}

function AvatarGradient({ name, size = "md", square = false, className, src, rounded }) {
  const gradient = getAvatarGradient(name);
  const initials = getInitials(name);
  const [imgError, setImgError] = useState(false);

  const sizeClasses = {
    xs: "w-5 h-5 text-[8px]",
    sm: "w-8 h-8 text-[10px]",
    md: "w-10 h-10 text-[12px]",
    lg: "w-12 h-12 text-[14px]",
    xl: "w-16 h-16 text-[18px]",
    profile: "w-[52px] h-[52px]  object-cover  rounded-[20px]  flex-shrink-0 text-[16px]",
    clockIn: "w-[82px] h-[82px]  object-cover  rounded-[20px] border-[2.5px] border-[rgba(255,255,255,0.30)] shadow-[0_4px_12px_rgba(0,0,0,0.15)] text-[24px]",
    shifts: "w-[34px] h-[34px]  object-cover flex-shrink-0 text-[11px]",
  };

  const showImage = src && !imgError;

  return (
    <div
      className={cn(
        "relative flex items-center  justify-center  text-white font-heading font-bold overflow-hidden ",
        rounded ? `rounded-[${rounded}]` : square ? "rounded-[8px]" : "rounded-full",
        !showImage && `bg-gradient-to-br ${gradient}`,
        sizeClasses[size],
        className
      )}
    >
      {showImage ? (
        <img
          src={src}
          alt={name}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        initials
      )}
      <div className={cn(
        "absolute inset-0 ring-1 ring-inset ring-black/10",
        rounded ? `rounded-[${rounded}]` : square ? "rounded-[8px]" : "rounded-full",
      )}></div>
    </div>
  );
}

function UserAvatar({ name, photo, size = "sm" }) {
  const [imageError, setImageError] = useState();
  if (photo && !imageError) {
    const sizeClass = size === "sm" ? "w-8 h-8" : "w-10 h-10";
    return <img src={photo} alt={name} onError={() => { setImageError(true) }} className={cn(sizeClass, "rounded-full object-cover flex-shrink-0")} />;
  }
  return <AvatarGradient name={name} size={size} />;
}

const ALL_ROLES = [
  { key: "employee", slug: "employee", label: "Employee", description: "Personal workspace", dotColor: "bg-orange-400" },
  { key: "team_lead", slug: "department_lead", label: "Team Lead", description: "Team management", dotColor: "bg-blue-400" },
  { key: "manager", slug: "manager", label: "Manager", description: "Multi-team management", dotColor: "bg-indigo-400" },
  { key: "dept_head", slug: "dept_head", label: "Department Head", description: "Department oversight", dotColor: "bg-cyan-400" },
  { key: "president", slug: "president", label: "President", description: "Division leadership", dotColor: "bg-rose-400" },
  { key: "hr_admin", slug: "hr_admin", label: "HR Admin", description: "HR management", dotColor: "bg-teal-400" },
  { key: "super_admin", slug: "admin", label: "Super Admin", description: "Full system access", dotColor: "bg-purple-400" },
];

const ROLE_BADGE_COLORS = {
  employee: { bg: "bg-orange-500/20", text: "text-orange-300" },
  team_lead: { bg: "bg-blue-500/20", text: "text-blue-300" },
  manager: { bg: "bg-indigo-500/20", text: "text-indigo-300" },
  dept_head: { bg: "bg-cyan-500/20", text: "text-cyan-300" },
  president: { bg: "bg-rose-500/20", text: "text-rose-300" },
  hr_admin: { bg: "bg-teal-500/20", text: "text-teal-300" },
  super_admin: { bg: "bg-purple-500/20", text: "text-purple-300" },
};

const ROLE_NAV_COLORS = {
  employee: { bg: "rgba(249,115,22,0.1)", shadow: "0 0 12px rgba(249,115,22,0.12)", icon: "#fb923c" },
  team_lead: { bg: "rgba(59,130,246,0.1)", shadow: "0 0 12px rgba(59,130,246,0.12)", icon: "#60a5fa" },
  manager: { bg: "rgba(99,102,241,0.1)", shadow: "0 0 12px rgba(99,102,241,0.12)", icon: "#818cf8" },
  dept_head: { bg: "rgba(6,182,212,0.1)", shadow: "0 0 12px rgba(6,182,212,0.12)", icon: "#22d3ee" },
  president: { bg: "rgba(244,63,94,0.1)", shadow: "0 0 12px rgba(244,63,94,0.12)", icon: "#fb7185" },
  hr_admin: { bg: "rgba(20,184,166,0.1)", shadow: "0 0 12px rgba(20,184,166,0.12)", icon: "#2dd4bf" },
  super_admin: { bg: "rgba(139,92,246,0.1)", shadow: "0 0 12px rgba(139,92,246,0.12)", icon: "#a78bfa" },
};

const ROLE_HIERARCHY = ["employee", "department_lead", "manager", "dept_head", "president", "hr_admin", "admin"];

function getAvailableRoles(actualRoleSlug) {
  const actualIdx = ROLE_HIERARCHY.indexOf(actualRoleSlug);
  if (actualIdx <= 0) return [];
  return ALL_ROLES.filter(r => ROLE_HIERARCHY.indexOf(r.slug) <= actualIdx);
}

function UserCard({ isCollapsed, isOpen, onToggle, onClose, sidebarWidth }) {
  const {state} = useContext(GlobalContext);
  const ref = useRef(null);
  console.log("state.user", state.user)
  const user = state.user;
  const activeRole = STATIC_ACTIVE_ROLE;

  const effectiveSidebarRole = slugToSidebarRole(activeRole.roleSlug);

  const badge = ROLE_BADGE_COLORS[effectiveSidebarRole];
  // const displayName = user?.firstName && user?.lastName
  //   ? `${user.firstName} ${user.lastName}`
  //   : user?.email?.split("@")[0] ?? "User";

  const displayName = user.name;

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function handleEscape(e) {
      if (e.key === "Escape") onClose();
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (isCollapsed) {
    return (
      <div className="px-2 py-3 border-t border-sidebar-border/50" ref={ref}>
        <button
          onClick={onToggle}
          className="w-full flex justify-center cursor-pointer"
          title={`${displayName} · ${activeRole.roleName}`}
        >
          <UserAvatar name={displayName} photo={user?.profilePhoto} size="sm" />
        </button>
        {isOpen && <PopoutPanel user={user} displayName={displayName} onClose={onClose} sidebarWidth={sidebarWidth} />}
      </div>
    );
  }

  return (
    <div className="px-3 py-3 border-t border-sidebar-border/50 mt-auto" ref={ref}>
      <button
        onClick={onToggle}
        className="w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-white/[0.06] transition-all cursor-pointer"
      >
        <UserAvatar name={displayName} photo={user?.profilePhoto} size="sm" />
        <div className="flex-1 text-left min-w-0">
          <div className="text-[12px] font-medium text-white/90 truncate leading-tight">{displayName}</div>
        </div>
        <span className={cn("text-[9px] font-semibold px-1.5 py-0.5 rounded-full flex-shrink-0", badge.bg, badge.text)}>
          {activeRole.roleName}
        </span>
      </button>
      {isOpen && <PopoutPanel user={user} displayName={displayName} onClose={onClose} sidebarWidth={sidebarWidth} />}
    </div>
  );
}

function PopoutPanel({ onClose, sidebarWidth, user, displayName }) {
  const { dispatch } = useContext(GlobalContext);
  // const user = STATIC_USER;
  const logout = () => {
    localStorage.removeItem("userSaleHub");
    localStorage.removeItem("tokenSaleHub");
    dispatch({type: "USER_LOGOUT"});
  };
  const viewAsRole = null;
  const setViewAsRole = noop;
  const isViewingAs = false;
  const activeRole = STATIC_ACTIVE_ROLE;
  const navigate = useNavigate();

  const actualRoleSlug = user?.roleSlug ?? "employee";
  const isSystemOwner = user?.systemOwner === true;
  const availableRoles = useMemo(() => getAvailableRoles(actualRoleSlug), [actualRoleSlug]);
  const switcherRoles = useMemo(
    () => isSystemOwner ? availableRoles : [],
    [availableRoles, isSystemOwner]
  );

  // const displayName = user?.firstName && user?.lastName
  //   ? `${user.firstName} ${user.lastName}`
  //   : user?.email?.split("@")[0] ?? "User";

  const handleRoleSwitch = (role) => {
    if (role.slug === actualRoleSlug) {
      setViewAsRole(null);
    } else {
      setViewAsRole({ roleSlug: role.slug, label: role.label });
    }
    navigate("/");
    onClose();
  };

  const handleExitViewAs = () => {
    setViewAsRole(null);
    navigate("/");
    onClose();
  };

  return (
    <div
      className="fixed z-50 bg-[#1a1c2e] rounded-xl border border-white/10 shadow-2xl animate-in slide-in-from-left-2 duration-200"
      style={{
        left: sidebarWidth + 12,
        bottom: 12,
        width: 268,
      }}
    >
      <div className="px-4 pt-4 pb-3 border-b border-white/[0.08]">
        <div className="flex items-center gap-3">
          <UserAvatar name={displayName} photo={user?.profilePhoto} size="md" />
          <div className="min-w-0">
            <div className="text-[13px] font-semibold text-white truncate">{displayName}</div>
            <div className="text-[11px] text-white/40">{user?.email ?? ""}</div>
          </div>
        </div>
      </div>

      {isViewingAs && (
        <div className="mx-3 mt-3 mb-1 px-2.5 py-2 rounded-lg bg-amber-500/10 border border-amber-500/20">
          <div className="flex items-center gap-2">
            <Eye className="w-3.5 h-3.5 text-amber-400 flex-shrink-0" />
            <span className="text-[11px] text-amber-300 font-medium flex-1">System Testing Mode — Viewing as: {viewAsRole?.label}</span>
            <button onClick={handleExitViewAs} className="text-amber-400 hover:text-amber-300 cursor-pointer">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
          <div className="text-[10px] text-amber-400/60 mt-0.5 ml-[22px]">Read-only mode · Write actions disabled</div>
        </div>
      )}

      {switcherRoles.length > 0 && (
        <div className="px-3 pt-3 pb-2">
          <div className="text-[9px] font-bold uppercase text-white/30 tracking-[0.12em] px-1 mb-2">SWITCH ROLE</div>
          {switcherRoles.map((role) => {
            const isCurrentRole = role.slug === actualRoleSlug;
            const isActive = role.slug === activeRole.roleSlug;
            const isLowerRole = ROLE_HIERARCHY.indexOf(role.slug) < ROLE_HIERARCHY.indexOf(actualRoleSlug);
            return (
              <button
                key={role.key}
                onClick={() => handleRoleSwitch(role)}
                className={cn(
                  "w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-colors cursor-pointer mb-0.5",
                  isActive ? "bg-white/[0.08]" : "hover:bg-white/[0.04]"
                )}
              >
                {isLowerRole
                  ? <Eye className="w-3.5 h-3.5 text-white/40 flex-shrink-0" />
                  : <span className={cn("w-2.5 h-2.5 rounded-full flex-shrink-0", role.dotColor)} />
                }
                <div className="flex-1 min-w-0 text-left">
                  <div className={cn("text-[12px] font-medium", isActive ? "text-white" : "text-white/70")}>
                    {role.label}
                    {isCurrentRole && <span className="text-[10px] text-white/30 ml-1.5">(Current)</span>}
                    {isLowerRole && <span className="text-[10px] text-white/30 ml-1.5">(View As · Read-only)</span>}
                  </div>
                  <div className="text-[10px] text-white/35">{role.description}</div>
                </div>
                {isActive && (
                  <span className={cn("w-1.5 h-1.5 rounded-full flex-shrink-0", isLowerRole ? "bg-amber-400" : "bg-blue-400")} />
                )}
              </button>
            );
          })}
        </div>
      )}

      <div className="mx-3 h-px bg-white/[0.08]" />

      <div className="px-3 py-2">
        {/* <Link to="/my-profile" onClick={onClose} className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg hover:bg-white/[0.04] transition-colors cursor-pointer">
          <User className="w-4 h-4 text-white/50" />
          <span className="text-[12px] text-white/70 flex-1 text-left">View profile</span>
          <ChevronRight className="w-3 h-3 text-white/30" />
        </Link>
        <Link to="/settings/account" onClick={onClose} className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg hover:bg-white/[0.04] transition-colors cursor-pointer">
          <Settings className="w-4 h-4 text-white/50" />
          <span className="text-[12px] text-white/70 flex-1 text-left">Account settings</span>
          <ChevronRight className="w-3 h-3 text-white/30" />
        </Link> */}
        <button onClick={() => { logout(); onClose(); }} className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg hover:bg-red-500/10 transition-colors cursor-pointer group">
          <LogOut className="w-4 h-4 text-white/50 group-hover:text-red-400" />
          <span className="text-[12px] text-white/70 group-hover:text-red-400 flex-1 text-left">Sign out</span>
        </button>
      </div>
    </div>
  );
}

export function Sidebar({ isCollapsed, onToggleCollapse }) {
  const location = useLocation();
  // Static permission/auth data (no context dependency)
  const hasPermission = hasPermissionStatic;
  const permissionsLoaded = true;
  const user = STATIC_USER;
  const viewAsRole = null;
  const setViewAsRole = noop;
  const isViewingAs = false;
  const appActiveRole = STATIC_ACTIVE_ROLE;
  const impersonatedEmployee = null;
  const isImpersonating = false;
  const [sectionCollapsed, setSectionCollapsed] = useState({});
  const [openPanel, setOpenPanel] = useState(null);

  const effectiveRoleSlug =
    isImpersonating && impersonatedEmployee
      ? impersonatedEmployee.roleSlug
      : appActiveRole.roleSlug;
  const activeRole = slugToSidebarRole(effectiveRoleSlug);

  const toggleSection = (label) => {
    setSectionCollapsed((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handlePanelToggle = useCallback((panel) => {
    setOpenPanel((prev) => (prev === panel ? null : panel));
  }, []);

  const handleClose = useCallback(() => {
    setOpenPanel(null);
  }, []);

  const sidebarWidth = isCollapsed ? 64 : 220;

  const isSystemOwner = user?.systemOwner === true;
  const isDelegatedSuperAdmin = user?.isDelegatedSuperAdmin === true;
  const showPlatform =
    (isSystemOwner || isDelegatedSuperAdmin) &&
    !isViewingAs &&
    !isImpersonating;

  const activeApp = STATIC_ACTIVE_APP;
  const activeAppSlug = activeApp?.slug ?? "people";

  const isTimeAttAdminLabel = [
    "hr_admin",
    "system_owner",
    "admin",
    "president",
  ].includes(effectiveRoleSlug);

  const baseNavSections = useMemo(() => {
    if (activeAppSlug === "payroll") {
      return buildNavSections(
        CANONICAL_PAYROLL_NAV,
        SECTION_ORDER_PAYROLL,
        hasPermission,
      );
    }
    if (activeAppSlug === "recruit") {
      return buildNavSections(
        CANONICAL_RECRUIT_NAV,
        SECTION_ORDER_RECRUIT,
        hasPermission,
      );
    }
    const sections = buildNavSections(
      CANONICAL_HRMS_NAV,
      SECTION_ORDER_HRMS,
      hasPermission,
    );
    for (const section of sections) {
      for (const item of section.items) {
        if (item.path === "/time-attendance") {
          item.name = isTimeAttAdminLabel ? "Time & Attendance" : "My Time";
        }
      }
    }
    return sections;
  }, [activeAppSlug, hasPermission, isTimeAttAdminLabel]);

  // Static badge counts (no API dependency)
  const unreadAnnouncementCount = 0;
  const unreadNotificationCount = 0;
  const requestNavCount = 0;
  const policyMgmtBadgeCount = 0;

  const isAdminRole =
    effectiveRoleSlug === "admin" ||
    effectiveRoleSlug === "hr_admin" ||
    effectiveRoleSlug === "system_owner";

  const navSections = useMemo(() => {
    const sections = baseNavSections
      .map((section) => ({
        ...section,
        items: section.items
          .filter((item) => {
            // if (!isAdminRole && item.path === "/holidays") return false;
            if (!isAdminRole && item.path === "/documents") return false;
            if (!isAdminRole && item.path === "/onboarding") return false;
            if (!isAdminRole && item.path === "/employees") return false;
            // if (!isAdminRole && item.path === "/people-hub") return false;
            if (!isAdminRole && item.path === "/analytics") return false;
            if (!isAdminRole && item.path === "/skill-directory") return false;
            if (!isAdminRole && item.path === "/audit-log") return false;
            if (!isAdminRole && item.path === "/transport") return false;
            if (
              !isAdminRole &&
              effectiveRoleSlug !== "dept_head" &&
              effectiveRoleSlug !== "manager" &&
              item.path === "/seats"
            )
              return false;
            if (!isAdminRole && item.path === "/administration/shifts")
              return false;
            return true;
          })
          .map((item) => {
            if (item.path === "/announcements" && unreadAnnouncementCount > 0) {
              return { ...item, badge: unreadAnnouncementCount };
            }
            if (item.path === "/company-policies" && policyMgmtBadgeCount > 0) {
              return {
                ...item,
                badge: policyMgmtBadgeCount,
                badgeColor: "#EF4444",
              };
            }
            if (item.path === "/requests" && requestNavCount > 0) {
              return { ...item, badge: requestNavCount, badgeColor: "#EF4444" };
            }
            if (item.path === "/notifications" && unreadNotificationCount > 0) {
              return {
                ...item,
                badge: unreadNotificationCount,
                badgeColor: "#EF4444",
              };
            }
            return item;
          }),
      }))
      .filter((section) => section.items.length > 0);

    if (showPlatform) {
      sections.push({ label: "Platform", items: PLATFORM_NAV });
    }

    return sections;
  }, [
    baseNavSections,
    unreadAnnouncementCount,
    unreadNotificationCount,
    policyMgmtBadgeCount,
    showPlatform,
    isAdminRole,
    requestNavCount,
  ]);

  return (
    <aside
      className={cn(
        "relative shrink-0 bg-sidebar border-r border-sidebar-border flex flex-col h-screen overflow-y-auto no-scrollbar transition-all duration-300",
        isCollapsed ? "w-16" : "w-[220px]",
      )}
    >
      <AppSwitcher
        isCollapsed={isCollapsed}
        isOpen={openPanel === "app"}
        onToggle={() => handlePanelToggle("app")}
        onClose={handleClose}
        sidebarWidth={sidebarWidth}
      />

      {!isCollapsed && (
        <div className="mx-5">
          <div className="h-px bg-white/6" />
        </div>
      )}

      {/* <OrgSwitcher
        isCollapsed={isCollapsed}
        isOpen={openPanel === "org"}
        onToggle={() => handlePanelToggle("org")}
        onClose={handleClose}
      /> */}

      {!isCollapsed && (
        <div className="mx-5">
          <div className="h-px bg-white/6" />
        </div>
      )}

      {isViewingAs && !isCollapsed && (
        <div className="mx-3 mt-2 mb-1 px-2.5 py-2 rounded-lg bg-amber-500/10 border border-amber-500/20">
          <div className="flex items-center gap-2">
            <Eye className="w-3 h-3 text-amber-400 shrink-0" />
            <span className="text-[10px] text-amber-300 font-medium flex-1 truncate">
              System Testing Mode — Viewing as: {viewAsRole?.label}
            </span>
            <button
              aria-label="Close"
              onClick={() => setViewAsRole(null)}
              className="text-amber-400 hover:text-amber-300 cursor-pointer"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        </div>
      )}

      <div className="flex-1 py-4 flex flex-col gap-1 overflow-y-auto no-scrollbar">
        {!permissionsLoaded &&
          effectiveRoleSlug !== "system_owner" &&
          !isCollapsed && (
            <div className="px-3 space-y-3 animate-pulse">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="flex items-center gap-2.5 px-3 h-[38px]">
                  <div className="w-4 h-4 rounded bg-white/10 shrink-0" />
                  <div
                    className="h-3 rounded bg-white/10 flex-1"
                    style={{ maxWidth: `${60 + (i % 3) * 20}%` }}
                  />
                </div>
              ))}
            </div>
          )}
        {navSections.map((section) => {
          const visibleItems = section.items;
          if (visibleItems.length === 0) return null;

          // console.log("nvaSections",visibleItems );

          const isSectionCollapsed = sectionCollapsed[section.label] ?? false;

          return (
            <div key={section.label}>
              {!isCollapsed && (
                <button
                  onClick={() => toggleSection(section.label)}
                  className="w-full px-5 mb-1 flex items-center justify-between group cursor-pointer"
                  style={{ paddingTop: 16, paddingBottom: 4 }}
                >
                  <span
                    className="text-[9px] font-semibold uppercase text-white/25 group-hover:text-white/50 transition-colors"
                    style={{ letterSpacing: "0.12em" }}
                  >
                    {section.label}
                  </span>
                  <ChevronDown
                    className={cn(
                      "w-3 h-3 text-white/25 group-hover:text-white/50 transition-all",
                      isSectionCollapsed && "-rotate-90",
                    )}
                  />
                </button>
              )}
              {isCollapsed && <div className="pt-2" />}
              {(!isSectionCollapsed || isCollapsed) && (
                <nav
                  className={cn(
                    "flex flex-col gap-0.5",
                    isCollapsed ? "px-2" : "px-3",
                  )}
                >
                  {visibleItems.map((item) => {
                    const isActive =
                      location.pathname === item.path ||
                      (item.path !== "/" && location.pathname.startsWith(item.path));
                    const roleColors = ROLE_NAV_COLORS[activeRole];
                    return (
                      <Link
                        key={`${section.label}-${item.name}-${item.path}`}
                        to={item.path}
                        title={isCollapsed ? item.name : undefined}
                        className={cn(
                          "group flex items-center gap-2.5 h-[38px] rounded-lg transition-all duration-500 relative",
                          isCollapsed ? "justify-center px-0" : "px-3",
                          isActive
                            ? "text-white"
                            : "text-white/60 hover:bg-white/4 hover:text-white",
                        )}
                        style={
                          isActive
                            ? {
                                backgroundColor: roleColors.bg,
                                boxShadow: roleColors.shadow,
                              }
                            : undefined
                        }
                      >
                        <item.icon
                          className={cn(
                            "w-[18px] h-[18px] stroke-[1.5] shrink-0 transition-colors duration-500",
                            !isActive && "text-white/50",
                          )}
                          style={
                            isActive ? { color: roleColors.icon } : undefined
                          }
                        />
                        {!isCollapsed && (
                          <>
                            <span
                              className={cn(
                                "text-[13px] flex-1",
                                isActive ? "text-white" : "text-white/60 group-hover:text-white",
                              )}
                              style={{
                                fontWeight: isActive ? 500 : 300,
                                letterSpacing: "0.025em",
                              }}
                            >
                              {item.name}
                            </span>
                            {item.badge !== undefined && item.badge > 0 && (
                              <span
                                data-testid={`sidebar-badge-${item.path.replace(/\//g, "")}`}
                                className="text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none min-w-[18px] text-center"
                                style={{
                                  backgroundColor:
                                    item.badgeColor || "var(--ds-accent)",
                                }}
                              >
                                {item.badge > 99 ? "99+" : item.badge}
                              </span>
                            )}
                          </>
                        )}
                        {isCollapsed &&
                          item.badge !== undefined &&
                          item.badge > 0 && (
                            <span
                              className="absolute top-1 right-1 w-2 h-2 rounded-full"
                              style={{
                                backgroundColor:
                                  item.badgeColor || "var(--ds-accent)",
                              }}
                            />
                          )}
                      </Link>
                    );
                  })}
                </nav>
              )}
            </div>
          );
        })}
      </div>

      <div
        className={cn(
          "py-4 border-t border-sidebar-border/50 mt-auto",
          isCollapsed ? "px-2" : "px-3",
        )}
      >
        {!isCollapsed && (
          <div className="mx-3 mb-2">
            <div className="h-px bg-white/6" />
          </div>
        )}
        <button
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          className={cn(
            "flex items-center gap-2.5 h-[38px] rounded-lg w-full text-white/60 hover:bg-white/4 hover:text-white transition-all cursor-pointer mb-1",
            isCollapsed ? "justify-center px-0" : "px-3",
          )}
        >
          {isCollapsed ? (
            <PanelLeft className="w-[18px] h-[18px] stroke-[1.5] text-white/50" />
          ) : (
            <PanelLeftClose className="w-[18px] h-[18px] stroke-[1.5] text-white/50" />
          )}
          {!isCollapsed && (
            <span
              className="text-[13px]"
              style={{ fontWeight: 300, letterSpacing: "0.025em" }}
            >
              Collapse
            </span>
          )}
        </button>
      </div>

      <UserCard
        isCollapsed={isCollapsed}
        isOpen={openPanel === "user"}
        onToggle={() => handlePanelToggle("user")}
        onClose={handleClose}
        sidebarWidth={sidebarWidth}
      />
    </aside>
  );
}
